/*

ashraf 10/16/2022  2700539021  added code comments in search, add user management.

*/

import {Checkbox} from '@material-ui/core';
import React, {useEffect, useState} from 'react';

// reusable checkbox component (2700549879)
const RoleCheckbox = ({name, rowData, handleChange, handleInputChange, index}) => {
  // console.log(rowData);
  return (
    <Checkbox
      className="role-checkbox"
      name={name}
      checked={rowData[name]}
      disabled={
        name === 'favourite' &&
        rowData?.moduleName !== 'Core Windows' &&
        rowData?.moduleName !== 'Custom Windows'
      }
      onChange={(eve, selection) => {
        handleChange(eve);
        handleInputChange(selection, index, eve, rowData);
      }}
      inputProps={{'aria-label': 'controlled'}}
    />
  );
};

export default RoleCheckbox;

// custom hook which returns current page data (2700549879)
export const useTable = (data, page, rowsPerPage) => {
  const [slice, setSlice] = useState([]);
  useEffect(() => {
    const slice = sliceData(data, page, rowsPerPage);
    setSlice([...slice]);
  }, [data, page, setSlice, rowsPerPage]);
  return {slice};
};

export const sliceData = (data, page, rowsPerPage) => {
  return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
};
